
import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const updateUser = async (id, data) => {
  const response = await axios.put(`${API_URL}/profile/`, data);
  return response.data;
};

export const resetUserPassword = async (id, data) => {
  const response = await axios.post(`${API_URL}/profile/password`, data);
  return response.data;
};

export const verifyEmail = async () => {
  const response = await axios.post(`${API_URL}/profile/send-verification-email`);
  return response.data;
};

export const uploadProfileImage = async (formData) => {
  const response = await axios.post(`${API_URL}/profile/profile-image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteProfileImage = async () => {
  const response = await axios.delete(`${API_URL}/profile/profile-image`);
  return response.data;
};

export const getUsers = async () => {
  const response = await axios.get(`${API_URL}/users`);
  return response.data.data;
};
